import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import './Footer.css';

const Footer = ({ currentPath = '/' }) => {
  return (
    <footer className="footer">
      {/* Overlapping Contact & Trial Card */}
      <div className="contact-banner">
        <div className="contact-banner__grid">
          {/* Left Side: Trial Card */}
          <div className="contact-banner__col contact-banner__col--trial">
            <h4 className="contact-banner__title">Start 3-Day Free Trial Today!</h4>
            <div className="contact-banner__content">
              <div className="contact-banner__img-wrapper">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/Images-2.jpg`}
                  alt="Family learning Quran online"
                  className="contact-banner__img"
                />
              </div>
              <div className="contact-banner__text-block">
                <p className="contact-banner__desc">
                  Join millions of people from around the world learning the Quran. Experience the rich reservoir of Quran learning with native Arabic male and female Quran teachers through a wide selection of courses with a free trial.
                </p>
                <a href="/free-trial/" className="contact-banner__btn">
                  Apply Now
                </a>
              </div>
            </div>
          </div>

          {/* Right Side: Contact Card */}
          <div className="contact-banner__col contact-banner__col--contact">
            <h4 className="contact-banner__title">Contact Us (24/7)</h4>
            <div className="contact-banner__content">
              <div className="contact-banner__img-wrapper">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/teach-quran-noorani-qaida-and-arabic-30-minutes-per-day.webp`}
                  alt="Girl learning Quran"
                  className="contact-banner__img"
                />
              </div>
              <div className="contact-banner__info-block">
                <ul className="contact-banner__list">
                  <li className="contact-banner__item">
                    <svg className="contact-banner__icon" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.62 10.79a15.15 15.15 0 006.59 6.59l2.2-2.2a1 1 0 011.11-.27c1.12.37 2.33.57 3.57.57a1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.24.2 2.45.57 3.57a1 1 0 01-.27 1.11l-2.2 2.2z" />
                    </svg>
                    <a href="tel:+17164577657">+1 716 457 7657 (USA)</a>
                  </li>
                  <li className="contact-banner__item">
                    <FaWhatsapp className="contact-banner__icon contact-banner__icon--whatsapp" />
                    <a href="https://wa.me/17164577657" target="_blank" rel="noopener noreferrer">+1 716-457-7657</a>
                  </li>
                  <li className="contact-banner__item">
                    <svg className="contact-banner__icon" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.62 10.79a15.15 15.15 0 006.59 6.59l2.2-2.2a1 1 0 011.11-.27c1.12.37 2.33.57 3.57.57a1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.24.2 2.45.57 3.57a1 1 0 01-.27 1.11l-2.2 2.2z" />
                    </svg>
                    <a href="tel:+16477385707">+1 647 738 5707 (Canada)</a>
                  </li>
                  <li className="contact-banner__item">
                    <svg className="contact-banner__icon" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.62 10.79a15.15 15.15 0 006.59 6.59l2.2-2.2a1 1 0 011.11-.27c1.12.37 2.33.57 3.57.57a1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.24.2 2.45.57 3.57a1 1 0 01-.27 1.11l-2.2 2.2z" />
                    </svg>
                    <a href="tel:+447441394281">+44 7441 394281 (UK)</a>
                  </li>
                  <li className="contact-banner__item">
                    <svg className="contact-banner__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                    <a href="mailto:info@alquranlesson.com">info@alquranlesson.com</a>
                  </li>
                </ul>
                <a href="/free-trial/" className="contact-banner__btn contact-banner__btn--start">
                  Get Started
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer Links Content */}
      <div className="footer__main">
        <div className="footer__container">
          {/* Footer Logo */}
          <div className="footer__logo-box">
            <a href="/" aria-label="Al Quran Lesson">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/FooterLogo.png`}
                alt="Al Quran Lesson"
                className="footer__logo-img"
              />
            </a>
          </div>

          {/* Social Icons */}
          <div className="footer__socials">
            <a href="https://www.facebook.com/readingonlinequran" target="_blank" rel="noopener noreferrer" className="footer__social-link">
              <svg fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1V12h3v3h-3v6.8c4.56-.93 8-4.96 8-9.8z" />
              </svg>
            </a>
            <a href="https://www.instagram.com/alquranlessons/" target="_blank" rel="noopener noreferrer" className="footer__social-link">
              <svg fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.051.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
              </svg>
            </a>
          </div>

          {/* Navigation Links */}
          <nav className="footer__nav">
            <ul className="footer__nav-list">
              <li><a href="/" className="footer__nav-link">HOME</a></li>
              <li><a href="/free-trial/" className="footer__nav-link">FREE TRIAL</a></li>
              <li><a href="/quran-classes-fee/" className="footer__nav-link">FEE PACKAGES</a></li>
              <li><a href="/about-us/" className="footer__nav-link">ABOUT US</a></li>
              <li><a href="/contact-us/" className="footer__nav-link">CONTACT US</a></li>
              <li><a href="/pay-fee-online/" className="footer__nav-link">PAY FEE ONLINE</a></li>
              <li><a href="/locations/" className="footer__nav-link">LOCATIONS</a></li>
              <li><a href="/privacy-policy/" className="footer__nav-link">PRIVACY POLICY</a></li>
              <li><a href="/terms-of-use/" className="footer__nav-link">TERMS OF USE</a></li>
            </ul>
          </nav>
        </div>
      </div>

      {/* Footer Bottom copyright & payment partners */}
      <div className="footer__bottom">
        <div className="footer__container footer__bottom-flex">
          <p className="footer__copyright">
            Copyright 2026 © All Rights Reserved
          </p>
          <div className="footer__payments">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/Footer-Image2.png`}
              alt="Payment options (PayPal, AMEX, Stripe)"
              className="footer__payment-img"
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

